document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.href.includes('products/')) return;
  const containers = document.querySelectorAll('.an--img-zoom-container');
  containers.forEach(container => {
    const img = container.querySelector('img');
    if (!img) return;

    const zoom = document.createElement('div');
    zoom.className = 'an--zoom-result';
    container.appendChild(zoom);

    const zoomSize = { w: 220, h: 220 };
    const zoomLevel = 1;

    function setBackgroundSize() {
      const bgW = img.naturalWidth * zoomLevel;
      const bgH = img.naturalHeight * zoomLevel;
      zoom.style.backgroundSize = `${bgW}px ${bgH}px`;
      zoom.style.display = 'none';
    }

    if (img.complete) {
      setBackgroundSize();
    } else {
      img.addEventListener('load', setBackgroundSize);
    }

    container.addEventListener('mouseenter', (e) => {
      zoom.style.backgroundImage = `url("${img.currentSrc || img.src}")`;
      zoom.style.width = zoomSize.w + 'px';
      zoom.style.height = zoomSize.h + 'px';
      zoom.style.display = 'block';
    });
    container.addEventListener('mousemove', (e) => {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const cx = Math.max(0, Math.min(x, rect.width));
      const cy = Math.max(0, Math.min(y, rect.height));

      const percentX = (cx / rect.width) * 100;
      const percentY = (cy / rect.height) * 100;
      zoom.style.backgroundPosition = `${percentX}% ${percentY}%`;

      const offset = 18;
      let left = cx + offset;
      let top = cy + offset;

      if (left + zoomSize.w > rect.width) {
        left = cx - zoomSize.w - offset;
      }

      if (top + zoomSize.h > rect.height) {
        top = cy - zoomSize.h - offset;
      }
      left = Math.max(0, Math.min(left, rect.width - zoomSize.w));
      top = Math.max(0, Math.min(top, rect.height - zoomSize.h));
      zoom.style.left = `${left}px`;
      zoom.style.top = `${top}px`;
    });
    container.addEventListener('mouseleave', () => {
      zoom.style.display = 'none';
    });
    window.addEventListener('scroll', () => zoom.style.display = 'none', { passive: true });
    container.addEventListener('touchstart', () => zoom.style.display = 'none');
  });
});
